var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{class:_vm.classes,attrs:{"tag":"article"}},[_vm._t("default",function(){return [_c('transition',{attrs:{"name":_vm.$route.meta.transition || ''}},[_c('router-view',{key:_vm.$route.fullPath + '&' + _vm.$store.state.time.current,class:{ 'pt-8': _vm.hasHeader }})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }